import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import * as VuexRouterSync from 'vuex-router-sync';
import VueLog from '@dreipol/vue-log';
import { VueReCaptcha } from 'vue-recaptcha-v3';

import AppRoot from 'framework/base/root.vue';
import initVuex from 'framework/vuex';
import initRouter from 'framework/router';
import registry from './registry';
import vueLogConfig from './vue-log-config';

/**
 * Bootstrap the vue root instance
 * @return {Promise} A promise returning when the registry has loaded all components and the app was initialized
 */
export function init() {
    // NOTE: Plugin initialisation is run before registry because new merge strategies might be applied by plugins.
    Vue.use(Vuex);
    Vue.use(VueRouter);
    Vue.use(VueLog, vueLogConfig);
    Vue.use(VueReCaptcha, {
        siteKey: globals.config.recaptchaSitekey,
        loaderOptions: {
            autoHideBadge: true,
        },
    });

    return registry().then(() => {
        AppRoot.store = initVuex();
        AppRoot.router = initRouter();
        const unsync = VuexRouterSync.sync(AppRoot.store, AppRoot.router); // eslint-disable-line no-unused-vars

        const app = new Vue(AppRoot);

        // Instantiate the root vue instance
        return app.$mount('#root');
    });
}
